import { cache, } from "./cache";

export const awaitValue = ( key: string, ) => {
	return new Promise((resolve, reject) => {
		const to = setTimeout(() => {
			// console.error("TIMEOUT", key);
			// console.log("CACHE.get(key)", cache.get(key));
			// console.trace();
			// clearTimeout(to);
			clearInterval(inte);
			resolve(0);
			// reject(new Error(`awaitValue timed out after 5 seconds`));
		}, 5000);
		const inte = setInterval(() => {
			try {
				if(cache.has(key)) {
					const { value, ready, } = cache.get(key);
					if(!ready) {
						return;
					}
					clearInterval(inte);
					clearTimeout(to);
					return resolve(value);
				}
				clearInterval(inte);
				clearTimeout(to);
				reject(new Error(`Awaiting cache but it does not have key ${key}`));
			}
			catch(error) {
				clearInterval(inte);
				clearTimeout(to);
				reject(error);
			}
		}, 25);

	});
}
